import { TQualifyChoice } from "../shared/types/qualifyChoices.type";

export function transformTraining(data: TQualifyChoice) {

    let payload: Partial<TQualifyChoice> = {}
    Object.entries(data).forEach((entity) => {
        if (entity[1] || typeof entity[1] === 'boolean') {
            payload[entity[0] as keyof TQualifyChoice] = entity[1]
        } else {
            payload[entity[0] as keyof TQualifyChoice] = null
        }

    })

    return payload
}